import { Button, Card, Panel } from '@/components/Bicester';
import { Form } from '@/components/formik-rsuite';
import { useRequest } from 'ahooks';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { defaultExpressInfo, expressSchema } from './constants';
import { SiteContext } from '..';
import Toolbar from '../components/Toolbar';
import { LEVEL_TYPE } from '@/constants';
import { Alert } from 'rsuite';
import { push } from '@/utils/history';
import { fetchAddEditExpress } from '@/services/site/express';
import { IconButton } from 'rsuite5';
import Image from '@/components/Bicester/Image';

const Express = () => {
  const { member } = React.useContext(SiteContext);

  const { run: addEditExpress, loading: addEditExpressLoading } = useRequest(fetchAddEditExpress, {
    manual: true,
  });

  const formik = useFormik({
    initialValues: defaultExpressInfo,
    validationSchema: expressSchema,
    onSubmit(values, actions) {
      const data = Object.assign({}, values, {
        expressage_items: JSON.stringify(values.expressage_items),
        [member?.level === LEVEL_TYPE.NOT ? 'not_member_id' : 'member_id']: member?.id,
      });
      addEditExpress(data)
        .then((res) => {
          if (res?.id) {
            const { id } = res;
            Alert.success(res?.msg ?? '保存成功');
            push(`/site-service/record/info/express/${id}`);
          }
        })
        .catch((e) => {
          actions.setErrors(e.formError);
        });
    },
  });

  return (
    <FormikProvider value={formik}>
      <Form guard>
        <Panel
          leftShadow
          style={{
            minHeight:
              'calc(100vh - var(--headerHeight) - var(--navBarHeight) - var(--toolBarHeight) - 195px)',
          }}
          loading={addEditExpressLoading}
        >
          <Card smDivider>
            <FieldArray name="expressage_items">
              {({ insert, remove, push }) => (
                <>
                  <Toolbar
                    title="商品快递登记"
                    handleAdd={() => push({ expressage_no: '' })}
                    handleReset={formik.resetForm}
                  />
                  <div className="flex">
                    <Card.Input required label="快递公司" formKey="courier_company" />
                    <Card.Input
                      className="flex-[2]"
                      label="备注"
                      placeholder="如有保价，备注保价金额"
                      formKey="remark"
                      labelWeight={1}
                      contentWeight={3}
                    />
                    <Card.Input required label="收费总计" inputType="number" formKey="money" />
                  </div>
                  <div className="flex-1">
                    {formik.values.expressage_items.length > 0 &&
                      formik.values.expressage_items.map((item, index) => (
                        <div className="flex" key={index}>
                          <div className="w-[25%] relative">
                            <Card.Input
                              required
                              label="快递单号"
                              formKey={`expressage_items.${index}.expressage_no`}
                            />
                            <IconButton
                              className={`w-[17px] h-[17px] ml-[5px] ${
                                index === 0 && formik.values.expressage_items.length <= 1
                                  ? 'invisible'
                                  : ''
                              }`}
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: -22,
                                height: 47,
                                zIndex: 1,
                              }}
                              onClick={() => remove(index)}
                            >
                              <Image src="/resources/images/delete.svg" />
                            </IconButton>
                          </div>
                          {index === 0 && (
                            <div className="flex w-[50%]">
                              <Card.Input
                                required
                                label="物品数量"
                                inputType="number"
                                formKey="num"
                              />
                              <Card.Picker
                                label="是否到付"
                                formKey="is_not_pay"
                                pickerType="TorF"
                              />
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </>
              )}
            </FieldArray>
          </Card>
          <div className="flex justify-end mt-[20px]">
            <Button type="submit" className="px-[70px]">
              确认提交
            </Button>
          </div>
        </Panel>
      </Form>
    </FormikProvider>
  );
};

export default Express;
